import { render, staticRenderFns } from "./indexCtesMdfe.vue?vue&type=template&id=54b15bf1&scoped=true"
import script from "./indexCtesMdfe.vue?vue&type=script&lang=js"
export * from "./indexCtesMdfe.vue?vue&type=script&lang=js"
import style0 from "./indexCtesMdfe.vue?vue&type=style&index=0&id=54b15bf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b15bf1",
  null
  
)

export default component.exports